import React, { Fragment, createRef } from "react";
import classnames from "classnames";
import Icon from "../../icon";
import { HeaderProps } from "..";
import styles from "./style.less";

export interface HeaderExpandProps extends HeaderProps {
  expandDisabled?: boolean;
  expandIconColor?: string;
  expandClose?: () => void;
}

export interface HeaderExpandState {
  expand: boolean;
}

class HeaderExpand extends React.Component<
  HeaderExpandProps,
  HeaderExpandState
> {
  private _expand: React.RefObject<HTMLDivElement> = createRef();

  constructor(props: HeaderExpandProps) {
    super(props);
    this.state = {
      expand: false,
    };
  }

  onExpandVisible = () => {
    if (this.props.expandDisabled) return;
    this.setState({
      expand: !this.state.expand,
    });
  };

  onExpandEnd = () => {
    const { expand } = this.state;
    const { expandClose } = this.props;
    if (!expand && expandClose) {
      expandClose();
    }
  };

  render() {
    const {
      closeIconType = "close",
      className,
      closeIconColor = "#ff0136",
      expandIconColor = "#000",
      onClose,
      renderContent,
      renderSubmit,
      children,
    } = this.props;
    const { expand } = this.state;

    return (
      <Fragment>
        <div
          className={classnames(styles.header, className, {
            [styles.headerHasSubmit]: !!renderSubmit,
          })}
        >
          <div
            id="sunzi-header-close"
            className={classnames(styles.headerClose, "sunzi-header-close")}
            onClick={onClose}
          >
            <Icon type={closeIconType} color={closeIconColor} size={30} />
          </div>
          <div className={styles.headerContent} onClick={this.onExpandVisible}>
            {renderContent}
          </div>
          {!this.props.expandDisabled && (
            <div
              className={styles.headerExpandArrow}
              onClick={this.onExpandVisible}
            >
              <Icon
                type={expand ? "up" : "down"}
                size={20}
                color={expandIconColor}
              />
            </div>
          )}
          <div className={styles.headerSubmit}>{renderSubmit}</div>
        </div>
        <div
          className={styles.headerExpand}
          style={{
            height: expand ? this._expand.current?.offsetHeight : 0,
          }}
          onTransitionEnd={this.onExpandEnd}
        >
          <div ref={this._expand} className={styles.headerExpandContent}>
            {children}
          </div>
        </div>
        {expand && (
          <div
            className={styles.headerExpandMask}
            onClick={this.onExpandVisible}
          />
        )}
      </Fragment>
    );
  }
}

export default HeaderExpand;
